const formatAmounts = (monto, t: (_key: string) => string) => {
  if (typeof monto !== 'number' || !Number.isFinite(monto)) {
    return t('Invalid amount');
  }
  return monto.toLocaleString('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export default formatAmounts;

export function formatCurrency(
  value: number,
  location: 'USD' | 'ARS',
  showDecimals = true
): string {
  const localeMap: Record<'USD' | 'ARS', string> = {
    USD: 'en-US',
    ARS: 'es-AR'
  };

  const locale = localeMap[location];

  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: showDecimals ? 2 : 0,
    maximumFractionDigits: showDecimals ? 2 : 0
  }).format(value);
}

export const formatStsAmounts = (monto) => {
  const parsedMonto = Number(monto);

  if (Number.isFinite(parsedMonto)) {
    return parsedMonto.toLocaleString('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  } else {
    return 'N/A';
  }
};

export const formatAmountARS = (amount: number, t): string => {
  if (typeof amount !== 'number' || isNaN(amount)) return t('Invalid amount');

  const parts = amount.toFixed(2).split('.');

  const integerWithThousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `$ ${integerWithThousands},${parts[1]} ${t('USD')}`;
};

// Formatea puntos: separador de miles, sin decimales
export const formatPoints = (
  value: number | string,
  locale: string = 'es-AR'
): string => {
  // Admite number o string; conserva el signo si viniera negativo
  const normalized =
    typeof value === 'string'
      ? Number(value.replace(/[^\d-]/g, ''))
      : Number(value);

  if (!Number.isFinite(normalized)) return '0';

  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 0
  }).format(Math.trunc(normalized));
};

// Parsea un string removiendo separadores de miles y devuelve solo números
export const parseNumber = (value: string | number): string => {
  if (!value) return '';
  return value.toString().replace(/\./g, '');
};

// Formatea números enteros con separadores de miles
export const formatInteger = (
  value: number | string,
  locale: string = 'es-AR'
): string => {
  const normalized = typeof value === 'string' ? Number(value) : Number(value);

  if (!Number.isFinite(normalized) || normalized < 0) return '0';

  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 0
  }).format(Math.trunc(normalized));
};
